import React, { Component } from "react";
import "./Issues.css";

class Issues extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
        
        
      </div>
    );
  }
}

export default Issues;
